import { brand, marketingUrlFromEnv } from "../brand";

/**
 * Marketing site origin for the active brand, from REACT_APP_MARKETING_URL_<BRAND_ID>
 * (wired up by scripts/apply-brand.js). Local: typically http://localhost:3000.
 */
function resolveMarketingOrigin(): string {
  const fromEnv = marketingUrlFromEnv?.trim();
  const origin = (fromEnv || brand.marketingUrl || "").replace(/\/$/, "");
  return origin;
}

export const MARKETING_ORIGIN = resolveMarketingOrigin();

export function marketingUrl(path: string) {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  return `${MARKETING_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}
